import {
    ActionIcon,
    Button,
    Group,
    Stack,
    ThemeIcon,
    Title,
} from "@mantine/core";
import i18n from "../../i18n";
import {
    getLangCodeFromEnum,
    LanguageEnum,
    HasEditorPrivileges,
    HasAdminPrivileges,
} from "../../types";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import IconArrowLeft from "../../assets/arrow-left.svg?react";
import {SettingsBox} from "./components/settings-components/SettingsBox";
import {LanguageSelectField} from "./components/settings-components/LanguageSelectField";
import {ResponseTypeSelectField} from "./components/settings-components/ResponseTypeSelectField";
import {SidebarPositionSelectField} from "./components/settings-components/SidebarPositionSelectField";
import {ChatEngineSelectField} from "./components/settings-components/ChatEngineSelectField";
import {DebugIndicatorToggle} from "./components/settings-components/DebugIndicatorToggle";
import {ExperimentalModeToggle} from "./components/settings-components/ExperimentalModeToggle";
import {InternalFeaturesToggle} from "./components/settings-components/InternalFeaturesToggle";
import {RoleProtection} from "./components/RoleProtection";
import {bffApi} from "./bffApi";
import {NonEditableField} from "./components/settings-components/NonEditableField";
import classes from "./SettingsPage.module.css";

export function SettingsPage() {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const setLanguage = (language: LanguageEnum) => {
        i18n.changeLanguage(getLangCodeFromEnum(language));
    };
    const user = bffApi.endpoints.getUser.useQuery();

    return (
        <Stack className={classes.page}>
            <Group className={classes.titleBox}>
                <ActionIcon
                    variant="subtle"
                    color="gneis.8"
                    radius="xl"
                    onClick={() => navigate("/")}
                >
                    <IconArrowLeft />
                </ActionIcon>
                <Title order={2} className={classes.title}>
                    {t("settings.accountDetails")}
                </Title>
            </Group>
            <SettingsBox title={t("settings.accountDetails")}>
                <NonEditableField
                    label={t("settings.field.name.title")}
                    description={t("settings.field.name.description")}
                    value={user.data?.navn ?? ""}
                />
                <NonEditableField
                    label={t("settings.field.email.title")}
                    description={t("settings.field.email.description")}
                    value={user.data?.epost ?? ""}
                />
                <NonEditableField
                    label={t("settings.field.company.title")}
                    description={t("settings.field.company.description")}
                    value={user.data?.kundeNavn ?? ""}
                />
            </SettingsBox>
            <SettingsBox title={t("settings.title")}>
                <LanguageSelectField />
                <RoleProtection
                    allowedRoles={HasEditorPrivileges}
                    hideable={false}
                    style={{display: "block"}}
                >
                    <ChatEngineSelectField />
                    <InternalFeaturesToggle />
                    <DebugIndicatorToggle />
                    <SidebarPositionSelectField />
                </RoleProtection>
                <RoleProtection
                    allowedRoles={HasAdminPrivileges}
                    hideable={false}
                    style={{display: "block"}}
                >
                    <ExperimentalModeToggle />
                </RoleProtection>
            </SettingsBox>
        </Stack>
    );
}
